interface MentorTipIconProps {
  className?: string;
  onClick?: () => void;
  width?: number;
  height?: number;
}

export const MentorTipIcon = ({
  className,
  onClick,
  width,
  height,
}: MentorTipIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 45 46"
    className={className}
    width={width}
    height={height}
    onClick={onClick}
  >
    <path
      d="M40 21.5C40 10.7304 31.2696 2 20.5 2C9.73045 2 1 10.7304 1 21.5C1 32.2696 9.73045 41 20.5 41C31.2696 41 40 32.2696 40 21.5Z"
      fill="#17295B"
    />
    <path
      opacity="0.9"
      d="M11 13H15.8534L20.9794 25.506H21.1975L26.3236 13H31.1768V31.6136H27.3596V19.4984H27.2052L22.3882 31.5227H19.7887L14.9718 19.4529H14.8173V31.6136H11V13Z"
      fill="white"
    />
    <g clip-path="url(#clip0_2_34)">
      <path
        d="M43.5714 34.5C43.5714 28.701 38.9664 24 33.2857 24C27.6051 24 23 28.701 23 34.5C23 40.299 27.6051 45 33.2857 45C38.9664 45 43.5714 40.299 43.5714 34.5Z"
        fill="#38A0DA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.3333 29.7917C31.7803 29.4614 32.3351 29.25 32.8937 29.25H39.1631C39.3389 29.25 39.5021 29.3186 39.607 29.4502C39.7118 29.5817 39.7384 29.7512 39.6929 29.9148L39.5615 30.3872C39.56 30.3925 39.5585 30.3978 39.5569 30.403L39.2401 31.5414C39.1581 31.8359 38.9582 32.0927 38.7119 32.2747C38.4656 32.4567 38.1563 32.5761 37.8395 32.5761H33.5522L33.2828 33.5439H36.4251C36.601 33.5439 36.7642 33.6125 36.869 33.7441C36.9739 33.8757 37.0005 34.0452 36.955 34.2087L36.8235 34.6811C36.8222 34.6857 36.8209 34.6904 36.8195 34.695L36.5021 35.8353C36.4202 36.1299 36.2203 36.3866 35.974 36.5686C35.7276 36.7506 35.4183 36.87 35.1016 36.87H32.5812C32.5303 36.87 32.4665 36.8904 32.4079 36.9337C32.3493 36.977 32.3123 37.031 32.2992 37.0783L31.8436 38.7153C31.7616 39.0099 31.5618 39.2666 31.3154 39.4486C31.0691 39.6306 30.7598 39.75 30.4431 39.75H28.7945V39.75H28.6941C28.5182 39.75 28.355 39.6814 28.2502 39.5498C28.1453 39.4182 28.1187 39.2487 28.1642 39.0852L30.0557 32.2887C30.0577 32.2814 30.0598 32.2741 30.0619 32.2668L30.386 31.1026C30.5305 30.5831 30.8862 30.1219 31.3333 29.7917ZM30.5137 32.4069L28.6222 39.2033C28.61 39.2474 28.6221 39.2666 28.6263 39.2719C28.6305 39.2771 28.6467 39.2935 28.6941 39.2935H29.202C29.2301 39.2935 29.259 39.2907 29.2883 39.2854C29.3182 39.2799 29.3486 39.2716 29.3789 39.2608C29.4374 39.2397 29.4955 39.2088 29.5496 39.1688C29.6591 39.0879 29.7356 38.982 29.7647 38.8777L31.4934 32.6662C31.538 32.5059 31.6449 32.3712 31.7715 32.2776C31.8507 32.2192 31.944 32.172 32.0449 32.1449C32.0519 32.143 32.059 32.1412 32.066 32.1396C32.1201 32.1267 32.1762 32.1196 32.2334 32.1196H37.8395C38.0347 32.1196 38.2449 32.0442 38.4232 31.9125C38.6016 31.7807 38.7316 31.6047 38.7821 31.4232L38.877 31.082C38.7702 31.1198 38.6565 31.1413 38.5407 31.1413H32.227C31.8635 31.1413 31.4824 31.2807 31.1644 31.5156C30.8464 31.7505 30.6079 32.0689 30.5139 32.4069L30.5137 32.4069ZM39.1024 30.2721C39.0728 30.3754 38.9967 30.48 38.8882 30.5601C38.7788 30.641 38.6527 30.6848 38.5405 30.6848H32.2268C31.7417 30.6848 31.2616 30.8682 30.8756 31.1534C30.8707 31.1571 30.8657 31.1607 30.8608 31.1644C30.9838 30.7793 31.2605 30.4209 31.6219 30.1539C32.0009 29.8739 32.4567 29.7065 32.8937 29.7065H39.1631C39.2104 29.7065 39.2266 29.7228 39.2308 29.7281C39.235 29.7334 39.2472 29.7526 39.2349 29.7967V29.7967L39.2348 29.7966L39.1033 30.269C39.103 30.2701 39.1027 30.2711 39.1024 30.2721ZM30.0761 39.2935H30.4431C30.6382 39.2935 30.8484 39.2182 31.0268 39.0864C31.2051 38.9547 31.3351 38.7786 31.3856 38.5972L31.8412 36.9601C31.8858 36.7998 31.9927 36.6651 32.1193 36.5715C32.2459 36.478 32.4087 36.4135 32.5812 36.4135H35.1016C35.2967 36.4135 35.507 36.3382 35.6853 36.2064C35.8636 36.0747 35.9936 35.8986 36.0441 35.7172L36.1391 35.3759C36.0449 35.4092 35.9453 35.4299 35.8437 35.4343C35.83 35.4349 35.8163 35.4352 35.8026 35.4352H32.9805C32.8046 35.4352 32.6414 35.3666 32.5366 35.235C32.4317 35.1035 32.4051 34.934 32.4506 34.7704L33.0613 32.5761H32.2334C32.2148 32.5761 32.1946 32.5788 32.1736 32.5844C32.1368 32.594 32.0975 32.6123 32.0602 32.6398C32.0016 32.6831 31.9646 32.7371 31.9515 32.7844L30.2228 38.9959C30.1928 39.1036 30.1417 39.2039 30.0761 39.2935ZM36.497 34.0906V34.0906C36.5092 34.0466 36.4971 34.0273 36.4929 34.022C36.4886 34.0167 36.4725 34.0004 36.4251 34.0004H33.1559L32.9087 34.8885C32.8965 34.9326 32.9087 34.9518 32.9129 34.9571C32.9171 34.9624 32.9332 34.9787 32.9806 34.9787H35.8028C35.8091 34.9787 35.8155 34.9785 35.822 34.9783C35.9291 34.9736 36.0471 34.9303 36.1503 34.854C36.2598 34.7731 36.3363 34.6673 36.3653 34.5629L36.4968 34.0906L36.497 34.0906Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_34">
        <rect
          width="21"
          height="21"
          fill="white"
          transform="translate(23 24)"
        />
      </clipPath>
    </defs>
  </svg>
);

MentorTipIcon.defaultProps = {
  className: "",
  onClick: undefined,
  width: 45,
  height: 46,
};
